var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar"},[_c('img',{staticClass:"nav-bar-img",attrs:{"src":require("../../static/img/pcnew1.png"),"alt":""}}),_vm._l((_vm.navList),function(item,index){return _c('div',{key:index,staticClass:"nav-bar-div",class:index == _vm.menuIndex?'acho': ''},[_c('a',{attrs:{"href":item.link}},[_vm._v(_vm._s(item.name))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }